





































import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";
import { Material } from "@/utils/material";

@Component
export default class MaterialForm extends Vue {
  @Prop({ required: true }) material!: Material;
  @Prop({ required: true }) updateMaterial!: (material: Material) => void;
  @Prop({ required: true }) deleteMaterial!: () => void;

  name = "";
  kFactor = 10;

  created() {
    this.name = this.material.name;
    this.kFactor = this.material.kFactor;
  }

  valid = true;
  requiredRule(name: string) {
    return (v) => !!v || `${name} is required`;
  }

  validate() {
    //@ts-ignore
    this.$refs.form.validate();
    this.updateMaterial({ name: this.name, kFactor: this.kFactor });
  }
  reset() {
    //@ts-ignore
    this.$refs.form.reset();
  }
  resetValidation() {
    //@ts-ignore
    this.$refs.form.resetValidation();
  }
}
